<template>
  <v-app-bar class="header-tab" height="48px" flat color="orange accent-4">
    <v-toolbar-title>現在管理者としてログイン中です。</v-toolbar-title>

    <v-tab @click="Edit">このプロダクトを編集する</v-tab>
    <v-tab @click="Logout">サインアウト</v-tab>
  </v-app-bar>
</template>

<script>
import firebase from "firebase"
// import { minpuroproducts } from "../../../firebase.config";
export default {
  methods: {
    Edit() {
      this.$router.push({ path: `/edit/${this.productId}` })
    },
    Logout() {
      firebase.auth().signOut()
    },
  },
  computed: {
    productId() {
      return this.$route.params.id
    },
  },
}
</script>

<style lang="scss" scoped></style>
